import { getReferralFees } from '../../api/commissionProgressApi';
import AccountantCommissionListWrapper from './accountantCommissionListWrapper';
import { Box } from '@mui/material';

/**
 * All RF — every referral fee, of both kinds, in one table.
 *
 * The same columns as All PSC so there is nothing new to learn, plus the ones that only
 * make sense here: who referred, who bears the fee, the rate it was derived from, whether
 * that referrer is also a customer of ours, and where the money is paid.
 *
 * Why this page cannot just be All PSC pointed at "RefC": an ASTERN-BORNE fee has no
 * CommissionProgress row at all — deliberately, so it never touches the commission pot —
 * so a list built on commission rows would show the exception and hide the default.
 * (user 2026-10-14: "can we have another RF << as ReferralFee page. where all referral
 * fee inside. put the same as psc columns. need to be agent etc too.")
 *
 * BOTH kinds are listed, always. The backend query walks SALES carrying a referral rather
 * than commission rows, so Agent-borne and Astern-borne both appear and the Borne By column
 * is what tells them apart. (user 2026-10-14: "actually can put all whether its by agent or
 * by astern. all need to put")
 */
const RF_COLUMNS = [
    'salesId', 'depositDate', 'customer',
    // The sale's own agent and co-agent — a referral is always read against who sold it.
    'agent', 'coAgent',
    'referrer', 'referrerIsCustomer',
    // The whole referral money block sits TOGETHER, immediately beside Commission, so the
    // fee can be read against the commission on one screen instead of scrolling the table
    // to its right-hand edge to find out who is paying.
    // (user 2026-10-14: "refer paid by put beside the agent commission column")
    'commission', 'referralRate', 'referralPaidBy', 'referralPayout', 'referrerBank',
    // Cust Progress stays — the customer paying is what makes a referral fee due.
    // Comm Progress is gone: it tracks a CommissionProgress row that an Astern-borne fee
    // does not have. (user 2026-10-14)
    'custProgress', 'status',
    'productCategory', 'productEnergy',
    'asternDiscount', 'agentDiscount', 'finalPrice',
    // No 1st/2nd/3rd Pay columns. They read a CommissionProgress row, and an
    // Astern-borne fee has none by design — so on the common case they are five
    // permanently empty columns pushing Final Price off the right-hand edge.
    // (user 2026-10-14: "remove the 1st pay 2nd pay 3rd pay etc. left the final price")
    'actions',
];

export default function AllRfList() {
    return (
        <div>
            <Box sx={{ mb: 2 }}>
                <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: '#0F172A', fontFamily: "'Poppins', sans-serif" }}>All RFC</h2>
                <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748B', fontFamily: "'Poppins', sans-serif" }}>Referral commission records</p>
            </Box>

            <AccountantCommissionListWrapper
                apiCall={getReferralFees}
                visibleColumns={RF_COLUMNS}
                // Routed on the SALE, not on a commission record: an Astern-borne fee has no
                // CommissionProgress row to point at, and those are the majority here.
                rowLink={(row) => {
                    const id = row?.salesDetailsForCommissionProgress?.salesId;
                    return id ? `/accounting/referral/${id}` : null;
                }}
            />
        </div>
    );
}
